const Dark = {
  background: "#0F0920",
  primary: "#0368FF",
  text: "#F2F0FF",
  secondary: "#FF3E95",  // fixed spelling
  hover: "#1b1d22",
  sell: "#e9113c",
  buy: "#399918",
};

const Light = {
  background: "#FFFFFF",
  primary: "#0368FF",
  text: "#303641",
  secondary: "#FF3E95",  // fixed spelling
  hover: "#f6f7f8",
  sell: "#e9113c",
  buy: "#399918",
};

export { Dark, Light };
